import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { Constants } from '../../common';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
    override format(date: Date, displayFormat: any): string {
        if (displayFormat === Constants.dateFormat) {
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }
        return super.format(date, displayFormat);
    }
}
